import styled from "styled-components";

export const IntegrationsListWrapper = styled.div`
  width: 100%;
  min-height: 100%;
  text-align: center;
`;

export const IntegrationsTable = styled.table`
  background-color: white;
  margin: auto;
  margin-top: 5rem;
  padding: 2rem;
  font-size: 1.3rem;
  width: 90%;
`;

export const TableTitle = styled.h2`
  font-size: 2.5rem;
  margin-top: 3rem;
`;

export const TableDescription = styled.p`
  font-size: 1.1rem;
  text-align: left;
  width: 90%;
  margin: 2rem auto 0;
`;

export const TableRow = styled.tr``;

export const TableHeader = styled.thead`
`;

export const HeaderCell = styled.th`
  text-align: center;
  border: grey 2px solid;
  min-width: 7rem;
`;

export const TableCell = styled.td`
  border: grey 2px solid;
  max-width: 15%;
  text-align: center;
  height: 4rem;
  ${props => {
    if(props.valid !== undefined){
        return `background-color: ${props.valid ? "#80d185" : "#f06980"};`
    }
}}
  
`;

export const TableBody = styled.tbody``;

export const StatusIndicator = styled.div`
  width:20px; 
  height:20px; 
  border-radius: 100%; 
  color: white; 
  text-align:center;
  background: ${props => props.valid ? "#7DB787" : "#E87F72"};
  margin: auto;
`
